export const ADD_TRAVELERS = "Add Travelers";
export const ADD_CONTACT_INFO = "Add Contact Information";
export const APPLY_REWARDS = "Apply Rewards";
export const CONFIRM_AND_BOOK = "Confirm and Book";
